const TrustPilot = ({ }: any) => {
    return (
        <div className="trustpilot-widget" data-locale="en-GB" data-template-id="5419b6a8b0d04a076446a9ad" data-businessunit-id="64591e4dc7f147454e8a6566" data-style-height="24px" data-style-width="100%" data-theme="light" data-min-review-count="0" data-without-reviews-preferred-string-id="1" data-style-alignment="center">
            <a href="https://uk.trustpilot.com/review/filmanize.com" target="_blank" rel="noopener">Trustpilot</a>
        </div>
    )
}

export default TrustPilot;